<template>
  <div class="calendar-popover">
    <el-popover
     placement="left-start"
     :width="isTimeslot ? 400 : 250"
     trigger="hover"
     :open-delay="0"
     :popper-options="{
       container: 'calendar-popover-container'
     }"
     :reference="reference"
     ref="popover">

     <h3
       :style="{
         backgroundColor: isTimeslot ? eventData.color : '',
         color:           isTimeslot ? contrastColor   : eventData.color,
       }"
       :class="{
         'calendar-popover-heading': true,
         'is-timeslot':              isTimeslot,
         'is-other':                 !isTimeslot
        }">
        {{eventData.title}}
      </h3>

     <template v-if="isTimeslot">
       <!-- TODO: More description about what this event is, explain it to users -->
       <!-- TODO: Alternatively use inline editor here. Would work out of the box -->
       <strong>From:</strong> {{eventData.data.from|shortDateTime}}<br>
       <strong>To:</strong> {{eventData.data.to|shortDateTime}}<br>
       <strong>Duration (h):</strong> {{eventData.data.duration/60}}<br>
       <strong>Duration (min):</strong> {{eventData.data.duration}}<br>
       <br>

       <el-button
         disabled
         size="small"
         type="danger"
         @click="onTimeslotDelete" >
         {{eventData.data.exception ? 'Delete Exception' : (
           eventData.data.deleted ? 'Undo Deletion' :
           'Delete weekly event once' )
         }}
       </el-button>

     </template>
     <template v-else>

       <strong>From:</strong> {{eventData.start|shortDateTime}}<br>
       <strong>To:</strong> {{eventData.end|shortDateTime}}<br>

       <!-- TODO: additional event info here -->
       <!-- TODO: show delete button -->
       <!-- TODO: show start session button -->
     </template>
     <!--
     <pre>
       Info: {{parentData}}
       Additional: {{eventData.title}}
     </pre>
     -->
   </el-popover>
   </div>
</template>

<script>
import Color from 'color';

export default {
  props: {
    reference: {},
    parentData: {
      default: () => ({
        test1: -1
      })
    },
    eventData: {}
  },
  beforeDestroy() {
    // console.log("- beforeDestroy");
    const popoverComp = this.$refs.popover;
    // console.log("this.$refs.popover", this.$refs.popover);
    // console.log("popoverComp.$refs.popper", popoverComp.$refs.popper);
    // console.log("popoverComp.popper", popoverComp.popper);
    // console.log("popoverComp.popperJS", popoverComp.popperJS);
    popoverComp.doDestroy();
  },
  computed: {
    contrastColor() {
      return Color( this.eventData.color ).isLight() ? 'black' : 'white';
    },
    isTimeslot() {
      return this.eventData.data.source === 'TSC';
    }
  },
  methods: {
    onTimeslotDelete() {
      console.log("onTimeslotDelete");
      alert('TODO')
    }
  }
}
</script>

<style>
.calendar-popover-heading.is-timeslot {
  padding: 0.25em 0.5em;
  border-radius: 5px;
}
.calendar-popover-heading.is-other {
}
</style>
